import { useDispatch,useSelector } from "react-redux";
import { setOfflineERR } from "../redux/chartoptions";
import { useState } from "react";
import IndividualComponentPopup from "./individualcomponentpopup";



function OfflineErr(){

    const [showModal,setShowModal] = useState(false);
   

    const myData = useSelector(state => state.offlineApi);

    let current_Err = myData.offline_Err[0];

        
        
        const dispatch = useDispatch();
        const checked = useSelector(state => state.chartOption.offline_Err)

        const showPopup = () =>{
            setShowModal(true);
        }
    
        const hidePopup = () =>{
            setShowModal(false);
        }

    return(
        <>
            <div className="parameter" id="offline-err" onClick={showPopup}>                    
                <div className="label2">
                    <input type="checkbox" id="offline_err" checked={checked} onChange={(e) => {dispatch(setOfflineERR(e.target.checked))}} />
                    <label htmlFor="offline_err" >Offline &shy;Err</label>
                </div>
                    
                <div className="parameter_ul">
                    <ul>
                        <li type="none">Current Err : {parseFloat(current_Err).toFixed(2)} <br/> </li>
                    </ul>
                </div>
            </div>
            {showModal && <IndividualComponentPopup hider={hidePopup} bgcolor={"#a0bfe070"} />}
        </>
    );
}

export default OfflineErr;